import { render, staticRenderFns } from "./AddTaskDialog.vue?vue&type=template&id=2b186089"
import script from "./AddTaskDialog.vue?vue&type=script&lang=js"
export * from "./AddTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./AddTaskDialog.vue?vue&type=style&index=0&id=2b186089&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDialog,VIcon})
